<template>
  <v-dialog v-model="visible" persistent max-width="638">
    <v-card class="v-dialog--custom" v-if="visible">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">{{ $t(`${namespace}.allowEmployeeAccessDialogTitle`) }}</span>
        <v-btn
          :disabled="isLoading"
          class="v-dialog--custom__close mr-2"
          fab
          flat
          color="gray-6"
          @click="close"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0">
        <p class="pb-2">{{ $t(`${namespace}.allowEmployeeAccessDialogText1`) }}</p>
        <p class="pb-2">{{ $t(`${namespace}.allowEmployeeAccessDialogText2`) }}</p>
        <p class="pb-2">{{ $t(`${namespace}.allowEmployeeAccessDialogText3`) }}</p>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />

        <a
          v-if="!isLoading"
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          :disabled="isLoading"
          :loading="isLoading"
          round
          depressed
          color="accent"
          @click.native="allowEmployeeAccess"
        >
          {{ $t(`${namespace}.allowEmployeeAccessDialogBtnLabel`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AllowEmployeeAccessDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    company: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    routeId () {
      return this.$route.params.id ? Number(this.$route.params.id) : null
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyDetailsPage',
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    close () {
      this.$emit('close')
    },

    async allowEmployeeAccess () {
      this.isLoading = true

      try {
        const companyId = this.company && this.company.id
          ? this.company.id
          : this.routeId

        if (!companyId) throw new Error()

        await this.$apiService.allowPlatformAccessToAllEmployees(companyId)
        this.close()
        this.showAlert({
          type: 'success',
          message: this.$t(`${this.namespace}.allowEmployeeAccessSuccess`)
        })
      } catch (err) {
        console.log('Error', err)
        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.allowEmployeeAccessError`)
        })
      }

      this.isLoading = false
    }
  }
}
</script>
